import { FaInstagram, FaLinkedin, FaXTwitter, FaFacebook, FaTiktok } from "react-icons/fa6";
import logo from '../assets/Logo2.png'
import React from 'react'

function Footer() {
  return (
    <div className='bg-[#fbc903] rounded-tl-gr rounded-tr-gr mt-12 font-grFont py-[46px]'>
      <div className='flex flex-col lg:flex-row gap-[50px] lg:gap-[15%] xl:gap-[38%] justify-center mt-[40px] mx-5 '>
        <div className='flex flex-row lg:flex-col lg:gap-[150px]'>
          <img src={logo} className=' w-full max-w-[146px] h-[34px] ' alt="Logo"></img>
          <div className="lg:flex lg:flex-col  flex flex-col w-full lg:gap-[20px]">
            <div className='flex flex-row-reverse xl:gap-[30px] max-w-[200px] xl:max-w-fit justify-between'>
              <a
                href="https://www.linkedin.com/company/gadgetsreborn/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="w-[24px] h-[24px]" />
              </a>
              <a
                href="https://www.instagram.com/gadgetsreborn/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="w-[24px] h-[24px]" />
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaXTwitter className="w-[24px] h-[24px]" />
              </a>
              <a
                href="https://www.facebook.com/gadgetsreborn.info"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook className="w-[24px] h-[24px]" />
              </a>
              <a
                href="https://www.tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok className="w-[24px] h-[24px]" />
              </a>
            </div>
            <div className="hidden w-full lg:flex font-[400] font-plus-jakarta-sans leading-[18px] text-[12px]">
              <p>Copyright © 2024 Gadgets Reborn LLC.</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:gap-[90px] gap-[20px]">
          <div className="flex flex-col lg:flex-row self-center gap-[70px] lg:gap-[40px] w-full font-[400] leading-[24px] text-[16px]">
            <div className="flex-row flex gap-[30px]">
              <div className="flex flex-col w-1/2 gap-[12px] lg:mr-4">
                <p className="font-[700] font-DMSans">Company</p>
                <a href="https://www.gadgetsreborn.store/pages/about-us" className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">About Us</a>
                <a className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">Contact Us</a>
              </div>
              <div className="flex flex-col w-1/2 gap-[12px] lg:mr-4">
                <p className="font-[700] font-DMSans whitespace-nowrap">Join our Community</p>
                <a href="" className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">Twitter</a>
                <a href="https://www.instagram.com/gadgetsreborn/" className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">Instagram</a>
                <a href="https://www.facebook.com/gadgetsreborn.info" className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">Facebook</a>
                <a href="" className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">Tiktok</a>
                <a href="https://www.linkedin.com/company/gadgetsreborn/" className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">LinkedIn</a>
              </div>
            </div>
            <div className="flex flex-col w-full gap-[12px]">
              <p className="font-[700] font-DMSans">Support</p>
              <a href="https://www.gadgetsreborn.store/pages/help-centre" className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">Help Center</a>
              <a href="https://zfrmz.com/LKzppogcURAGYveQMGL6" className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">For Partners</a>
              {/* <a className="whitespace-nowrap font-plus-jakarta-sans cursor-pointer w-1/4">Suggest a Feature</a> */}
            </div>
          </div>
          <div className="flex flex-row-reverse gap-[50px] lg:gap-[30px] leading-[18px] font-[400] text-[12px] mt-10 mr-6 lg:mr-0 lg:mt-[-2px]">
            <a className="cursor-pointer text-[#101828] font-plus-jakarta-sans whitespace-nowrap">Complaints</a>
            <a href="https://www.gadgetsreborn.store/pages/terms-conditions" className="cursor-pointer text-[#101828] font-plus-jakarta-sans whitespace-nowrap">Terms and Conditions</a>
            <a href="https://www.gadgetsreborn.store/pages/privacy-policy" className="cursor-pointer text-[#101828] font-plus-jakarta-sans whitespace-nowrap">Privacy Policy</a>
          </div>
        </div>
        <div className="flex lg:hidden font-[400] leading-[18px] text-[12px] mt-[-16px] ">
          <p>Copyright © 2024 Gadgets Reborn LLC.</p>
        </div>
      </div>
    </div>
  )
}

export default Footer;